/**
 * Returns a list of key metrics for a project.
 * e.g. https://api.tokenterminal.com/v3/internal/lists/market-sectors
 * @example
 * const { data: marketSectors } = useMarketSectorsList()
 */

import { useQuery } from "@tanstack/react-query"
import { apiGET } from "data/api/get"

const getMarketSectorsList = () =>
  apiGET(
    `/v3/internal/lists/market-sectors` as "/v3/internal/lists/market-sectors"
  )

export type MarketSectorsListItem = Awaited<
  ReturnType<typeof getMarketSectorsList>
>["data"][number]

const useMarketSectorsList = () => {
  return useQuery<MarketSectorsListItem[]>({
    queryKey: ["market-sectors"],
    queryFn: async () => {
      const result = await getMarketSectorsList()
      return result.data
    },
    staleTime: 1000 * 60 * 10,
  })
}

export default useMarketSectorsList
